import styled from 'styled-components'
import { breackpoints, cores } from '../../styles'

export const Footer = styled.footer`
  background-color: ${cores.azul};
  color: ${cores.branco};

  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${breackpoints.desktop}) {
      justify-content: center;
    }
  }
`
export const Links = styled.ul`
  display: flex;
  li {
    margin-right: 20px;
    a {
      line-height: 70px;
      color: ${cores.branco};
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
  }

  @media(max-width: ${breackpoints.desktop}){
    display: none;
  }
`

export const Copyright = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;

  @media (max-width: ${breackpoints.tablet}) {
    flex-direction: column;
    padding: 20px 0;
  }
`
